import { Moment } from 'moment'

import { APP_INJECTOR } from 'app.module'
import { BaseDecorator } from './base.decorator'
import { DriverLicense } from 'models'

export class DriverLicenseDecorator extends BaseDecorator {

  constructor(protected object: DriverLicense) {
    super(object)
  }

  issuedAt(format: string): string {
    return this.object && this.object.issuedAt ? this.object.issuedAt.format(format) : ''
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/decorators/driver-license.decorator.ts